<template>
    <v-card outlined class="mx-auto s-layout-small mt-0">
      <v-card-title class="pa-0" style="justify-content: space-between;">
        <p class="ma-0">Thông tin đơn hàng</p>
        <p class="ma-0" v-if="contentOrder.isDetail && checkAuthorization('order-ctv-create_read') && !checkAuthorization('contact_read')">
          {{dataStatusCTV}}
        </p>
        <p class="ma-0" v-else>{{dataStatus}}</p>
      </v-card-title>
      <v-row>
        <v-col cols="12" sm="12" class="order-products-wrapper">
          <div class="order-module" :class="[$store.state.module.typeId == 2 ? 'flexColumnReserve' : 'flexColumn', disable ? 'disableOrder' : '']">
            <div class="order-tutor" v-show="(orderT && orderT.length > 0) || (orderGS.length == 0 && orderT.length == 0) && $store.state.module.typeId != 2">
            <div class="order-tutor-title">SẢN PHẨM THƯỜNG</div>
           <div class="order-tutor-table">
             <table class="table-small-screen">
                <tr>
                  <th style="width: 30%" class="pl-6">Tên sản phẩm</th>
                  <th style="width: 12%">Số lượng</th>
                  <th style="width: 21%">Đơn giá</th>
                  <th style="width: 15%">Thành tiền</th>
                  <th style="white-space: nowrap;width: 15%">Tên con</th>
                  <th v-if="stepOrder !== 3"></th>
                </tr>
                <tr v-for="(product, index) in orderT" :key="index">
                  <td class="order-active px-6">
                      <v-autocomplete
                        :disabled="isReadOnly || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                        v-model="product.productId"
                        :items="getNotGS()"
                        item-text="name"
                        item-value="idTemp"
                        class="ma-0 pa-0"
                        @change="changeProductT(product, index)"
                        item-disabled="disable"
                        :label="product.product && product.product.status == 'inactive' ? product.product.name : ''"
                      />
                  </td>
                  <td class="pr-6">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Số lượng"
                        :vid="'Số lượng' + index"
                        :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                      >
                      <v-text-field
                        :readonly="isReadOnly || stepOrder === 3"
                        type="number"
                        v-model="product.quantity"
                        label
                        class="ma-0 pa-0"
                        color="primary"
                        @input="changeQuantity('T',product, index)"
                        :disabled="product.disable || codeOrder === 'ĐHT'"
                        :error-messages="errors"
                      />
                      </validation-provider>
                  </td>
                  <td class="pr-6">
  <!--                  <validation-provider-->
  <!--                    v-slot="{ errors }"-->
  <!--                    name="Đơn giá"-->
  <!--                    :vid="'Đơn giá' + index"-->
  <!--                    :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"-->
  <!--                  >-->
  <!--                    <v-text-field-->
  <!--                      :readonly="isReadOnly || stepOrder === 3"-->
  <!--                      step="5000"-->
  <!--                      type="number"-->
  <!--                      v-model="product.price"-->
  <!--                      label-->
  <!--                      class="ma-0 pa-0"-->
  <!--                      :error-messages="errors"-->
  <!--                      color="primary"-->
  <!--                    />-->
  <!--                  </validation-provider>-->
  <!--                  <v-currency-field-->
  <!--                      class="ma-0 pa-0"-->
  <!--                      readonly-->
  <!--                      :value="(product.intoMoney / product.quantity)"-->
  <!--                  />-->
                          <v-text-field
                            readonly
                            step="5000"
                            v-model="product.price"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            :disabled="product.disable || codeOrder === 'ĐHT'"
                          />
                  </td>
                  <td class="pr-6">
                      <v-text-field
                          :readonly="isReadOnly || stepOrder === 3"
                          type="number"
                          v-model="product.intoMoney"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                          @input="changeIntoMoney('T', product, index)"
                          :disabled="codeOrder === 'ĐHT'"
                      />
  <!--                  <v-currency-field-->
  <!--                      class="ma-0 pa-0"-->
  <!--                      :readonly="isReadOnly || stepOrder === 3"-->
  <!--                      :value="(product.price * product.quantity)"-->
  <!--                  />-->
                  </td>
                  <td>
                      <v-autocomplete
                        :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                        v-model="product.customerId"
                        :items="childCustomers"
                        item-text="fullName"
                        item-value="id"
                        class="ma-0 pa-0"
                      />
                  </td>
                   <td class="text-center" style="position: relative">
                      <div class="delete-order" v-if="stepOrder !== 3" v-show="!isReadOnly && codeOrder !== 'ĐHT'" @click="onClickRemoteProduct('T', index)">
                        <b>Xoá</b>
                      </div>
                    </td>
                </tr>
          </table>
           <div class="tfool-total">
              <div class="tfool-total-name" style="width: 63%">
                <div style="text-align: left;">
                  <v-btn small v-if="stepOrder !== 3 && !isReadOnly && codeOrder !== 'ĐHT'" color="blue" @click="onClickAddProduct('T')">
                    <v-icon>mdi-plus</v-icon>Thêm sản phẩm
                  </v-btn>
                </div>
                <div class="total-price pr-6">
                  <b>TỔNG ĐƠN HÀNG:</b>
                </div>
              </div>
              <div  class="pl-1"><b class="price-color"> {{formatPrice(totalPriceT, 'đ')}}</b></div>
           </div>
           </div>
            <div class="add-order"  v-show="orderGS.length == 0">
              <v-btn depressed text class="font-weight-bold"  @click="onClickAddProduct('GS')">+ Thêm sản phẩm gia sư </v-btn>
           </div>
            </div>
            <div class="order-tutor" v-show="(orderGS && orderGS.length > 0) || (orderGS.length == 0 && orderT.length == 0) && $store.state.module.typeId == 2">
              <div class="order-tutor-title">SẢN PHẨM GIA SƯ</div>
              <div class="order-tutor-table">
                <table class="table-small-screen mobile-hidden">
                    <tr>
                      <th style="width: 14%"  class="pl-6">Loại đơn</th>
                      <th style="width: 13%">Môn học</th>
                      <th style="width: 13%">Loại giáo viên</th>
                      <th style="width: 13%">Gói</th>
                      <th  style="width: 10%">
                        Số lượng
                      </th>
                      <th style="width: 15%">Thành tiền</th>
                      <th style="white-space: nowrap;width: 15%">Tên con</th>
                      <th v-if="stepOrder !== 3"></th>
                    </tr>
                    <tr v-for="(product, index) in orderGS" :key="index">
                      <td class="order-active px-6">
                          <v-autocomplete
                            :disabled="isReadOnly || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                            v-model="product.orderType"
                            :items="order"
                            item-text="name"
                            item-value="id"
                            class="ma-0 pa-0"
                            item-disabled="disable"
                          />
                      </td>
                      <td class="pr-6">
                          <v-autocomplete
                            :items="SUBJECTS_SORT_CLASS"
                            item-text="lowCaseName"
                            item-value="code"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            :disabled="product.disable || codeOrder === 'ĐHT'"
                            v-model="product.product.monCode"
                            @change="resetOrder(product.product.monCode, index)"
                          />
                      </td>
                      <td class="pr-6">
                          <v-autocomplete
                            :items="getLoaiGv(product.product.monCode)"
                            item-text="name"
                            item-value="id"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            :disabled="product.disable || codeOrder === 'ĐHT'"
                            v-model="product.product.teacherType"
                            @change="resetOrder(product.product.teacherType, index)"
                          />
                      </td>
                      <td class="css-gs pr-6">
                          <v-autocomplete
                              :readonly="isReadOnly || stepOrder === 3"
                              class="ma-0 pa-0"
                              color="primary"
                              :disabled="codeOrder === 'ĐHT'"
                              v-model="product.productId"
                              :items="getGOI(product.product.monCode, product.product.teacherType)"
                              item-text="nameGoi"
                              item-value="idTemp"
                              @change="changeProductGS(product, index)"
                              :label="product.product && product.product.status == 'inactive' ? `1-${product.product.classType} : ${product.product.numberOfSection} buổi` : ''"
                          />
                      </td>
                      <td class="pr-6">
                        <validation-provider
                            v-slot="{ errors }"
                            name="Số lượng"
                            :vid="'Số lượng' + index"
                            :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                          >
                          <v-text-field
                              :readonly="isReadOnly || stepOrder === 3"
                              type="number"
                              label
                              class="ma-0 pa-0"
                              color="primary"
                              @input="changeQuantity('GS',product, index)"
                              v-model="product.quantity"
                              :error-messages="errors"
                              :disabled="codeOrder === 'ĐHT'"
                          />
                          </validation-provider>
                      </td>
                      <td class="pr-6">
                          <v-text-field
                              :readonly="isReadOnly || stepOrder === 3"
                              type="number"
                              label
                              class="ma-0 pa-0"
                              color="primary"
                              @input="changeIntoMoney('GS',product, index)"
                              v-model="product.intoMoney"
                              :disabled="codeOrder === 'ĐHT'"
                          />
                      </td>
                      <td>
                          <v-autocomplete
                            :disabled="isReadOnly || !product.productId || stepOrder === 3 || product.disable || codeOrder === 'ĐHT'"
                            v-model="product.customerId"
                            :items="childCustomers"
                            item-text="fullName"
                            item-value="id"
                            class="ma-0 pa-0"
                          />
                      </td>
                      <td  class="text-center" style="position: relative">
                        <div class="delete-order" v-show="!isReadOnly && codeOrder !== 'ĐHT' && stepOrder !== 3" @click="onClickRemoteProduct('GS', index)">
                          <b
                          >Xoá</b>
                          </div>
                      </td>
                    </tr>
                </table>
                <div class="tfool-total">
                    <div class="tfool-total-name" style="width: 63%">
                      <div  style="text-align: left;">
                        <v-btn small v-show="!isReadOnly && codeOrder !== 'ĐHT' && stepOrder !== 3" color="blue" @click="onClickAddProduct('GS')">
                          <v-icon>mdi-plus</v-icon>Thêm sản phẩm
                        </v-btn>
                      </div>
                      <div class="total-price pr-6">
                        <b>TỔNG ĐƠN HÀNG: </b>
                      </div>
                    </div>
                      <div class="pl-1"><b class="price-color">{{formatPrice(totalPriceGS, 'đ')}}</b></div>
                  </div>
              </div>
               <div class="order-deposit" v-if="(mode === 'create' && !_.isEmpty(orderGS) ) || (mode === 'edit' && !_.isEmpty(listTrail) && !_.isEmpty(orderGS))" style="background: #FAFAFA">
            <div class="deposit-name" style="width: 63%">
              <div  class="deposit-checkbox">
                <div class="deposit-checkbox mr-5">
                  <v-checkbox v-model="statusDepositOne" :disabled="statusDepositTwo || codeOrder === 'ĐHT' || mode === 'edit'"></v-checkbox>
                  <b :class="statusDepositTwo ? 'activeCheckbox' : ''">Đặt cọc trước tiền</b>
                </div>
              <div class="deposit-checkbox" v-if="!_.isEmpty(orderHT)">
                <v-checkbox v-model="statusDepositTwo" :disabled="statusDepositOne || codeOrder === 'ĐHT' || mode === 'edit'"></v-checkbox>
                <b :class="statusDepositOne ? 'activeCheckbox' : ''">Đặt cọc & Học thử</b>
              </div>
              </div>
              <div class="total-price pr-6" v-if="statusDepositOne || statusDepositTwo">
                <b>TIỀN CỌC: </b>
              </div>
            </div>
            <div class="pl-1" v-if="statusDepositOne || statusDepositTwo">
               <validation-provider
                v-show="stepOrder >= 2"
                v-slot="{ errors }"
                name="TIỀN CỌC"
                :rules="{
                  required: true,
                  min_value: 0,
                  max_value: totalPriceGS,
                }"
              >
                <!-- <v-text-field
                  type="number"
                  class="price-input-deposit"
                  color="green"
                  v-model="priceDeposit" dense :error-messages="errors" :disabled="codeOrder === 'ĐHT'" suffix="đ"
                  @input="countNeedMoney"
                  ></v-text-field> -->
                  <v-currency-field
                    class="price-input-deposit"
                    v-model="priceDeposit" dense :error-messages="errors" :disabled="codeOrder === 'ĐHT'" suffix="đ"
                    @input="changePriceDeposit"
                    color="green"
                  />
              </validation-provider>
            </div>
          </div>
              <div class="add-order" v-show="orderT.length == 0">
                  <v-btn depressed  @click="onClickAddProduct('T')" v-show="codeOrder !== 'ĐHT'" text class="font-weight-bold">+ Thêm sản phẩm thường </v-btn>
              </div>
            </div>
          </div>
          <div class="order-deposit mb-4" v-if="codeOrder == 'ĐHT'" :class="{disable : 'disableOrder'}">
            <div class="deposit-name" style="width: 63%">
              <div  class="deposit-checkbox">
              </div>
              <div class="total-price pr-6" v-if="statusDepositOne || statusDepositTwo">
                <b>CẦN THANH TOÁN TIẾP: </b>
              </div>
            </div>
            <div class="pl-1" v-if="statusDepositOne || statusDepositTwo">
              <!-- <v-text-field dense class="need-input-deposit" :disabled="codeOrder == 'ĐHT'" v-model="needMoney" suffix="đ">
              </v-text-field> -->
              <v-currency-field
                dense
                class="need-input-deposit"
                :disabled="codeOrder == 'ĐHT'" v-model="needMoney" suffix="đ"
              />
            </div>
          </div>
           <div class="order-module order-deposit" v-if="statusDepositTwo" :class="{disable : 'disableOrder'}">
            <div v-show="(orderHT && orderHT.length > 0)">
              <div class="order-tutor-table">
                <table class="table-small-screen mobile-hidden">
                    <tr>
                      <th style="width: 40%"  class="pl-6">{{ codeOrder == 'ĐHT' ? 'HOÀN TẤT GÓI' : 'CHỌN GÓI HỌC THỬ'}}</th>
                      <th style="width: 15%"> {{ codeOrder == 'ĐHT' ? 'SỐ BUỔI HOÀN TẤT' : 'SỐ BUỔI QUY ĐỔI CỌC'}}</th>
                      <th style="width: 45%"></th>
                    </tr>
                    <tr v-for="(product, index) in orderHT" :key="index">
                      <td class="order-active px-6">
                        <div class="order-deposit-names">{{showGoiHT(product)}}</div>
                      </td>
                      <td class="css-gs pr-6">
                           <validation-provider
                            v-slot="{ errors }"
                            name="Số buổi"
                            :vid="'Số buổi' + index"
                            :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0, max:4 }"
                          >
                          <v-text-field
                              v-if="codeOrder !== 'ĐHT'"
                              :readonly="isReadOnly || stepOrder === 3"
                              type="number"
                              label
                              class="ma-0 pa-0"
                              color="primary"
                             @input="changeQuantity('HT',product, index)"
                              v-model="product.quantity"
                              :error-messages="errors"
                              :disabled="priceDeposit == 0"
                              dense
                          />
                           <v-text-field
                              v-if="codeOrder === 'ĐHT'"
                              :readonly="isReadOnly || stepOrder === 3"
                              type="number"
                              label
                              class="ma-0 pa-0"
                              color="primary"
                             @input="changeQuantity('HTĐHT',product, index)"
                              v-model="product.resQuanty"
                              :error-messages="errors"
                              :disabled="codeOrder == 'ĐHT'"
                              dense
                          />
                          </validation-provider>
                      </td>
                      <td>
                      </td>
                    </tr>

                </table>
                <div class="total-price-deposit" v-if="codeOrder !== 'ĐHT'">Tiền quy đổi  : {{formatPrice(totalPriceTrail, 'đ')}}</div>
              </div>
            </div>
          </div>
          <v-expansion-panels class="mb-4 mobile-show" v-model="panel" multiple>
            <v-expansion-panel style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;">
              <v-expansion-panel-header class="px-0" id="support-filter-header"><b>Thông tin sản phẩm</b></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list-item three-line class="overflow-visible pa-0">
                  <v-list-item-content class="overflow-visible pa-0">
                    <div v-for="(product, index) in contentOrder.products" :key="`1${index}`" class="my-3" style="border-bottom: 1px solid black">
                      <div v-if="stepOrder !== 3 && !isReadOnly && index > 0" style="text-align: right; margin-right: 10px;">
                        <v-btn
                          style="margin-right: -20px;"
                          @click="onClickRemoteProduct(index)"
                          text
                          small
                        >
                          <v-icon>mdi-close-box</v-icon>
                        </v-btn>
                      </div>
                        <v-autocomplete
                          :disabled="isReadOnly || stepOrder === 3"
                          v-model="product.productId"
                          :items="getNotGS()"
                          item-text="name"
                          item-value="idTemp"
                          label="Tên sản phẩm"
                          class="ma-0 pa-0 mb-3"
                          @change="changeProduct(product, index)"
                        />
                        <validation-provider
                          v-slot="{ errors }"
                          name="Số lượng"
                          :vid="'Số lượng' + index"
                          :rules="{numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                        >
                          <v-text-field
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            v-model="product.quantity"
                            label="Số lượng"
                            class="ma-0 pa-0 mb-3"
                            color="primary"
                            @input="changeQuantity(product, index)"
                            :error-messages="errors"
                          />
                        </validation-provider>
  <!--                    <validation-provider-->
  <!--                      v-slot="{ errors }"-->
  <!--                      name="Đơn giá"-->
  <!--                      :vid="'Đơn giá' + index"-->
  <!--                      :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"-->
  <!--                    >-->
  <!--                      <v-text-field-->
  <!--                        :readonly="isReadOnly || stepOrder === 3"-->
  <!--                        step="5000"-->
  <!--                        type="number"-->
  <!--                        v-model="product.price"-->
  <!--                        label="Đơn giá"-->
  <!--                        class="ma-0 pa-0 mb-3"-->
  <!--                        :error-messages="errors"-->
  <!--                        color="primary"-->
  <!--                      />-->
  <!--                    </validation-provider>-->
                      <v-text-field
                          readonly
                          step="5000"
                          v-model="product.price"
                          label
                          class="ma-0 pa-0"
                          color="primary"
                      />
  <!--                    <v-currency-field class="ma-0 pa-0" readonly :value="(product.price * product.quantity)" />-->
                        <v-text-field
                            :readonly="isReadOnly || stepOrder === 3"
                            type="number"
                            v-model="product.intoMoney"
                            label
                            class="ma-0 pa-0"
                            color="primary"
                            @input="changeIntoMoney(product, index)"
                        />
                        <v-autocomplete
                          :disabled="isReadOnly || !product.productId || stepOrder === 3"
                          v-model="product.customerId"
                          :items="childCustomers"
                          item-text="fullName"
                          item-value="id"
                          class="ma-0 pa-0"
                          label="Tên con sử dụng"
                        />
                      <div v-if="stepOrder !== 3" v-show="index > 0 && !isReadOnly" class="text-left" style="position: relative">

                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <div>
                  <v-btn small v-if="stepOrder !== 3 && !isReadOnly" class="add-product-btn px-0" @click="onClickAddProduct">
                    <v-icon>mdi-plus</v-icon><span class="add-product-text">Thêm sản phẩm</span>
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12" class="pb-0">
          <!-- <validation-provider
            v-show="stepOrder >= 2"
            v-slot="{ errors }"
            name="Đã thanh toán"
            :rules="{
              required: true,
              min_value: 0,
              max_value: totalPrice,
            }"
          >
            <v-currency-field
              :readonly="isReadOnly || stepOrder === 3"
              label="Đã thanh toán"
              :error-messages="errors"
              :disabled="codeOrder === 'ĐHT'"
              class="ma-0 pa-0"
              v-model="contentOrder.paidAmount"
            />
          </validation-provider> -->
          <v-currency-field readonly label="Còn lại" :value="restPrice" :disabled="codeOrder === 'ĐHT'"/>
          <validation-provider v-slot="{ errors }" name="Hình thức thanh toán" rules="required">
            <v-autocomplete
              :disabled="isReadOnly || stepOrder === 3"
              v-model="contentOrder.paymentType"
              :items="orderPaymentTypes"
              label="Hình thức thanh toán *"
              class="ma-0 pa-0"
              :error-messages="errors"
            />
          </validation-provider>
          <validation-provider v-slot="{ errors }" name="Ghi chú đơn hàng" rules="max:255">
            <v-textarea
              :readonly="isReadOnly || stepOrder === 3"
              label="Ghi chú đơn hàng"
              rows="3"
              class="ma-0 pa-0"
              v-model="contentOrder.description"
              :error-messages="errors"
            />
          </validation-provider>
          <validation-provider v-slot="{ errors }" name="Note cho vận hành xếp lớp" rules="max:255">
            <v-textarea
              :readonly="isReadOnly || stepOrder === 3"
              label="Note cho vận hành xếp lớp"
              rows="3"
              class="ma-0 pa-0"
              v-model="contentOrder.noteSortClass"
              :error-messages="errors"
            />
          </validation-provider>
          <!-- <v-autocomplete
            v-if="!contentOrder.isDetail"
            :readonly="isReadOnly || stepOrder === 3"
            v-model="contentOrder.statusId"
            :items="getStatusList"
            item-text="name"
            item-value="id"
            label="Trạng thái"
          /> -->
        </v-col>
        <v-col cols="12" sm="12" class="py-0">
          <ul class="table-info">
            <li class="mb-2">
              <strong>Địa chỉ người nhận</strong>
            </li>
            <li class="mb-1">
              <p class="ma-0">
                <span class="font-weight-medium">Số điện thoại :</span>
                {{fullNamePhone}}
                <v-tooltip v-if="showChat" bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn class="icon-fb" icon small color="info" v-on="on"><v-icon>mdi-facebook-messenger</v-icon></v-btn>
                  </template>
                  <span>Nhắn tin</span>
              </v-tooltip>
              </p>
            </li>
            <li class="mb-1">
              <p class="ma-0">
                <span class="font-weight-medium">Địa chỉ :</span>
                {{_.get(shippingAddress, 'detailAddress', '')}}
              </p>
            </li>
            <li class="mb-1">
              <p class="ma-0">{{provinceAddress}}</p>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
  </template>

  <script>
  import { orderPaymentTypes , SUBJECTS_SORT_CLASS,  LOAI_GIAOVIEN } from '../../../helpers/constants';
  // import RepositoryFactory from '../../../repositories/RepositoryFactory';
  // const OrderRepository = RepositoryFactory.get('order');
  import moment from 'moment'
  import { string } from 'yargs';

  export default {
    props: {
      dataForm: {
        type: Object,
        default: () => {}
      },
      contentOrder: {
        type: Object,
        default: () => {}
      },
      contactStatus: {
        type: Object,
        default: () => ({})
      },
      contactStatusList: {
        type: Array,
        default: () => []
      },
      shippingAddress: {
        type: Object,
        default: () => {}
      },
      courseRegisters: {
        type: Array,
        default: () => []
      },
      childCustomers: {
        type: Array,
        default: () => []
      },
      stepOrder: {
        type: Number,
        default: -1
      },
      showChat: {
        type: Boolean,
        default: false
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      contactId: {
        type: Number,
        default: () => null
      },
      codeOrder: {
        type: String,
        default: () => ''
      },
      listTrail: {
        type: Object,
        default: () => {}
      },
      mode: {
        type: String,
        default: () => ''
      },
      disable: {
        type: Boolean,
        default: () => false
      }

    },
    data() {
      return {
        totalPriceOld: 0,
        orderPaymentTypes,
        panel: [0],
        // timeOrderTutor: null,
        listOrderDisable: [],
        listOrderTutor: [],
        SUBJECTS_SORT_CLASS,
        LOAI_GIAOVIEN,
        orderGS : [],
        orderT: [],
        order: [
          {
            id: 1,
            name: 'Đơn mới'
          },
          {
            id: 2,
            name: 'Gia hạn'
          },
        ],
        statusDepositOne: false,
        statusDepositTwo: false,
        orderHT: [],
        totalPriceTrail: 0,
        priceDeposit: null,
        dataLoaded: false,
        dataLoaded2: false,
        needMoney: null,
      };
    },
    async created() {
      this.checkGS();
      this.checkT();
      let result = _.map(this.orderGS, (o1) => {
        const foundProduct = _.find(this.courseRegisters, o2 => o1.productId === o2.idTemp && o2.classType == 1);
        return {...foundProduct, orderType: o1.orderType, quantity: o1.quantity, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
      })
      result = result.filter(s => s.id);
      const listTrail = _.get(this.listTrail, 'trailProductData', []);
      const listTrailGroup = _.get(this.listTrail, 'groupOrderData', []);
      this.dataLoaded = true;
      if (!_.isEmpty(listTrail)) {
         this.orderHT = _.map(result, (item) => {
          const foundItem = _.find(listTrail, (i) => {
            return i.productId == item.id;
          });
          return {...item, quantity: foundItem.trailLessons, intoMoney: foundItem.money, resQuanty: item.numberOfSection * item.quantity - foundItem.trailLessons }
        });
        const newList =
        this.statusDepositTwo = true;
      } else {
        this.orderHT = [];
        if(!_.isEmpty(listTrailGroup)) {
          this.statusDepositOne = true;
        }
      }

      if(this.$route.query.codeOrder && this.$route.query.codeOrder == 2) {
        this.priceDeposit = this.contentOrder.totalPrice - this.totalPriceT;
      }else {
        if(this.codeOrder == 'ĐC') {
          this.priceDeposit = this.contentOrder.totalPrice - this.totalPriceT;
        }
        if(this.codeOrder == 'ĐHT') {
          this.priceDeposit = this.totalPriceGS - this.contentOrder.totalPrice;
        }
      }
      this.totalPriceOld = this.totalPriceT + this.totalPriceGS
      this.countNeedMoney();
      this.totalPriceHT();

    },
    watch: {
      orderGS : {
        handler(val) {
          // let result = this.courseRegisters.filter(o1 => val.some(o2 => o1.idTemp === o2.productId && o1.classType == 1));
          const result = _.map(val, (o1) => {
            const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o2.classType == 1);
            return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
          })
          if (!this.dataLoaded) {
            this.priceDeposit = null
            this.orderHT = result.filter(s => s.id);
          }
          this.dataLoaded = false;

          this.totalPriceHT();
          if(_.isEmpty(this.orderHT)) {
            this.statusDepositTwo = false;
          }
          this.countNeedMoney();
          if(_.isEmpty(val)) {
            this.statusDepositOne = false
            this.statusDepositTwo = false
          }
        },
        deep: true,
      },
      orderT : {
        handler() {
          this.countNeedMoney();
        },
        deep: true,
      },
    },
    computed: {
      getStatusList() {
        let charFirstType =
          _.get(this.contactStatus, 'type', 'T').charAt(0) || 'T';
        const contactStatusList = [];
        const checkType = {};
        this.contactStatusList.forEach(contactStatus => {
          const typeContactStatus = contactStatus.type;
          if (typeContactStatus.includes(charFirstType)) {
            if (!checkType[typeContactStatus]) {
              checkType[typeContactStatus] = true;
              if (contactStatusList.length > 0) {
                contactStatusList.push({ divider: true });
              }
              contactStatusList.push({ header: typeContactStatus });
            }
            contactStatusList.push(contactStatus);
          }
        });
        return contactStatusList;
      },
      dataStatus() {
        return `Trạng thái: (${_.get(this.contactStatus, 'type', '')}-${_.get(
          this.contactStatus,
          'name',
          ''
        )})`;
      },
      dataStatusCTV() {
        return `Trạng thái: (${_.get(
            this.contactStatus,
            'name',
            ''
        )})`;
      },
      restPrice() {
        if(this.statusDepositOne || this.statusDepositTwo) {
          if (this.codeOrder === 'ĐHT') return this.needMoney;
          return +this.priceDeposit + Number(this.totalPriceT);
        }else {
          return this.totalPrice - Number(this.contentOrder.paidAmount);
        }
      },
      fullNamePhone() {
        return `${_.get(this.shippingAddress, 'receiver', '')} - ${_.get(
          this.shippingAddress,
          'phone',
          ''
        )}`;
      },
      provinceAddress() {
        return `${_.get(this.shippingAddress, 'xaName', '')} ${_.get(
          this.shippingAddress,
          'huyenName',
          ''
        )} ${_.get(this.shippingAddress, 'tinhName', '')}`;
      },
      totalPrice() {
        if(this.statusDepositOne || this.statusDepositTwo) {
          return this.priceDeposit;
        }else {
          return (
          this.orderGS.concat(this.orderT).reduce(
            (accumulator, product) => {
              return (
                accumulator +
                // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
                parseInt(_.get(product, 'intoMoney', 0))
              );
            },
            0
          ) || 0
        );
        }
      },
      totalPriceGS() {
        return (
         this.orderGS.reduce(
            (accumulator, product) => {
              return (
                accumulator +
                // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
                parseInt(_.get(product, 'intoMoney', 0))
              );
            },
            0
          ) || 0
        );
      },
      totalPriceT() {
        return (
          this.orderT.reduce(
            (accumulator, product) => {
              return (
                accumulator +
                // _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
                parseInt(_.get(product, 'intoMoney', 0))
              );
            },
            0
          ) || 0
        );
      },
    },
    methods: {
       changePriceDeposit() {
        if (this.dataLoaded2) {
            const result = _.map(this.orderGS, (o1) => {
              const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o2.classType == 1);
              return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, prices: o1.price, quantityGS: o1.quantity};
            })
            this.orderHT = result.filter(s => s.id);

            this.totalPriceHT();
            if(_.isEmpty(this.orderHT)) {
              this.statusDepositTwo = false;
            }
            this.countNeedMoney();
            if(_.isEmpty(this.orderGS)) {
              this.statusDepositOne = false
              this.statusDepositTwo = false
            }
        }
        this.dataLoaded2 = true;
      },
      countNeedMoney() {
        // let totalPrice = this.orderGS.concat(this.orderT).reduce((accumulator, product) => {
        //   return accumulator + parseInt(_.get(product, 'intoMoney', 0))
        // }, 0) || 0;

        let totalPrice = this.orderGS.reduce((accumulator, product) => {
          return accumulator + parseInt(_.get(product, 'intoMoney', 0))
        }, 0) || 0;
        this.needMoney = totalPrice - this.priceDeposit;
      },
      totalPriceHT(index) {
        if(_.isEmpty(this.orderHT)) {return}
        const money = this.orderHT.reduce(
            (accumulator, product) => {
              return (
                accumulator +
                parseInt(_.get(product, 'intoMoney', 0))
              );
            },
            0
          ) || 0;
        if (money > this.priceDeposit) {
          this.$swal({
            text: 'Tiền quy đổi phải nhỏ hơn tiền cọc!',
            type: 'error',
            timer: 1500
          });
          this.totalPriceTrail = 0
          this.orderHT[index].quantity = null
          return;
        }
        this.totalPriceTrail = money
      },
      onClickRemoteProduct(value, index) {
        this.$swal({
          title: 'Xóa sản phẩm',
          text: 'Bạn có thực sự muốn xoá ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ'
        }).then(async result => {
          if (result.value) {
            if(value == 'GS') {
              this.orderGS.splice(index, 1);
            }
            if(value == 'T') {
              this.orderT.splice(index, 1);
            }
          }
        });
      },
      onClickAddProduct(value) {
        if(value == 'GS') {
           this.orderGS.push({
            productId: '',
            orderType: '',
            quantity: 1,
            price: 0,
            customerId: '',
            intoMoney: 0,
            product: {
              monCode: '',
              teacherType: '',
            }
          })
        };
        if(value == 'T') {
           this.orderT.push({
            productId: '',
            quantity: 1,
            price: 0,
            customerId: '',
            intoMoney: 0,
          });
        }
      },
      changeProduct(product, index) {
        const productTemp = product;
        const data = this.courseRegisters.find(
          courseRegister => courseRegister.idTemp === productTemp.productId
        );
        productTemp.customerId = '';
        productTemp.price = data.price;
        this.contentOrder.products[index].intoMoney = product.price * product.quantity
      },
      changeProductGS(product, index) {
        const productTemp = product;
        const data = this.courseRegisters.find(
          courseRegister => courseRegister.idTemp === productTemp.productId
        );
        productTemp.customerId = '';
        productTemp.price = data.price;
        this.orderGS[index].intoMoney = product.price * product.quantity
      },
      changeProductT(product, index) {
        const productTemp = product;
        const data = this.courseRegisters.find(
          courseRegister => courseRegister.idTemp === productTemp.productId
        );
        productTemp.customerId = '';
        productTemp.price = data.price;
        this.orderT[index].intoMoney = product.price * product.quantity
      },
      changeQuantity(value, product, index) {
        if(value == 'GS') {
          this.orderGS[index].intoMoney = product.price * product.quantity
        }
        if(value == 'T') {
          this.orderT[index].intoMoney = product.price * product.quantity
        }
        if(value == 'HT') {
          if(!this.priceDeposit) {
             this.$swal({
              type: 'error',
              title: 'Cần nhập tiền cọc!',
              timer: 1500
            });
            this.orderHT[index].quantity = null
            return
          }
          this.orderHT[index].intoMoney =  Math.floor((product.prices/product.numberOfSection) * Number(product.quantity));
          if(this.codeOrder == 'ĐHT') {
            this.orderHT[index].intoMoney =  Math.floor((product.prices/product.numberOfSection) * Number(product.resQuanty));
          }
          this.orderHT[index].resQuanty = (this.orderHT[index].numberOfSection*this.orderHT[index].quantityGS) - this.orderHT[index].quantity;
          this.totalPriceHT(index);
        }
      },
      //  totalPriceHT() {
      //   return 12;
      // },
      changeIntoMoney(value, product, index) {
        if(value == 'GS') {
          this.orderGS[index].price = Math.round(+product.intoMoney / +product.quantity)
          const result = _.map(this.orderGS, (o1) => {
            const foundProduct = _.find(this.courseRegisters, o2 => o2.idTemp === o1.productId && o2.classType == 1);
            return {...foundProduct, orderType: o1.orderType, customerId: o1.customerId, price: o1.price};
          })
          this.orderHT = result.filter(s => s.id);
        }
        if(value == 'T') {
          this.orderT[index].price = Math.round(+product.intoMoney / +product.quantity)
        }
        if(value == 'HT') {
          this.orderHT[index].price = Math.round(+product.intoMoney / +product.quantity)
        }
      },
      checkGS() {
        this.orderGS = _.filter(this.contentOrder.products, function(product) { return product.productType && product.productType == 'GIA_SU' });
      },
      checkT() {
        this.orderT = _.filter(this.contentOrder.products, function(product) { return !product.productType || product.productType != 'GIA_SU' });
      },
      getGOI(monCode, teacherType) {
        // let checkGoi = _.filter(this.courseRegisters, function(item) {
        //   if (monCode.toUpperCase() == 'TA') {
        //     return item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.teacherType == teacherType && item.productType == 'GIA_SU'
        //   } else {
        //     return item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.productType == 'GIA_SU'
        //   }
        // })
        let checkGoi = monCode.toUpperCase() == 'TA' ?
          _.filter(this.courseRegisters, item => item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.productType == 'GIA_SU' && item.teacherType == teacherType) :
          _.filter(this.courseRegisters, item => item.monCode && item.monCode.toUpperCase() == monCode.toUpperCase() && item.productType == 'GIA_SU')
        checkGoi.map(s => {
          s.nameGoi = `1-${s.classType} : ${s.numberOfSection} buổi`
        })
        return checkGoi
      },
      getNotGS() {
        let checkNotGoi = _.filter(this.courseRegisters, function(item) { return item.productType != 'GIA_SU'})
        return checkNotGoi
      },
      getLoaiGv(monCode) {
        if (monCode.toLowerCase() == 'ta') {
          return LOAI_GIAOVIEN
        } else {
          return [LOAI_GIAOVIEN[0]]
        }
      },
      resetOrder(value, index) {
        this.orderGS[index].productId = '';
        this.orderGS[index].intoMoney = '';
        this.orderGS[index].customerId = '';
      },
      showGoiHT(product) {
        let name = ''
        this.order.map(s => {
          if(s.id == product.orderType) {
            name = s.name
          }
        })
        this.SUBJECTS_SORT_CLASS.map(s => {
          if(s.code == product.monCode) {
            name = name + ' - ' + s.lowCaseName
          }
        })
         this.LOAI_GIAOVIEN.map(s => {
          if(s.id == product.teacherType) {
            name = name + ' - ' + s.name
          }
        })
        return name + ' : ' + '1-' + product.classType + ' : ' + product.numberOfSection + ' buổi'
      },
    }
  };
  </script>

  <style scoped>
  ::v-deep .v-subheader.theme--light {
    font-size: 10px;
    font-weight: bold;
  }

  .add-product-btn {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #2196F3 !important;
    box-shadow: unset;
    text-underline-position: under;
    font-weight: bold;
  }

  .add-product-btn .add-product-text {
    text-decoration: underline;
    text-underline-position: under;
  }

  .delete-product-btn {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #F44336 !important;
    box-shadow: unset;
    text-underline-position: under;
    font-weight: bold;
    position: absolute;
    right: 20px;
  }

  .delete-product-btn .delete-product-text {
    text-decoration: underline;
    text-underline-position: under;
  }
  ::v-deep .order-active label.v-label.v-label--active.theme--light.primary--text {
      display: none;
  }
  .order-tutor-title {
      background: #F7F7FC;
      border-radius: 3px 3px 0px 0px;
      height: 24px;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 0px;
      text-align: left;
      display: flex;
      align-items: center;
      padding-left: 20px;
      padding-top: 3px;
  }
  ::v-deep .order-tutor table {
      background: #FAFAFA;
  }
  ::v-deep .order-deposit table {
      height: 113px;
  }

  .order-tutor {
      margin-bottom: 10px;
  }
  .order-tutor-table {
      overflow: auto;
      max-width: 100%;
      background: #FDF6E2;
  }
  tr.tfool-total {
      position: relative;
  }

  .total-price {
      /* position: absolute;
      left: 216px;
      display: flex;
      bottom: 15px;
      align-items: center; */
      font-size: 13px;
  }
  ::v-deep .css-gs label.v-label.v-label--active.theme--light.primary--text {
      display: none;
  }
  table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
  }
  table tr td {
      border-top: 1px solid #cfcfcf;
  }
  .order-deposit table tr td {
      border-top: none;
  }
  table tr:hover td {
      background: #f3f3f3;
  }
  .tfool-total {
      display: flex;
      background: #FAFAFA;
      padding: 10px 20px;
      align-items: center;
  }
  .tfool-total-name {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  .add-order {
      width: 100%;
      justify-content: right;
      display: flex;
  }
  table tr th {
    text-align: left;
  }
  .order-module {
    display: flex;
  }
  .flexColumn {
    flex-direction: column;
  }
  .flexColumnReserve {
    flex-direction: column-reverse;
  }
  .delete-order {
      color: #2196f3;
      cursor: pointer;
      margin-bottom: 7px;
      font-size: 13px;
  }
  .price-color {
      color: #FD1F6D;
  }
  .order-deposit {
      display: flex;
      align-items: center;
  }

  .deposit-name {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }

  .deposit-checkbox {
      display: flex;
      align-items: center;
  }
  b.activeCheckbox {
      color: #BDBDBD;
  }
  .total-price-deposit {
      font-family: Roboto;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 0px;
      text-align: left;
      display: flex;
      justify-content: right;
      padding: 25px;
      color: #828282;
  }
  ::v-deep .price-input-deposit input {
    color:  #008000 !important;
    font-weight: 700 !important;
    font-size: 14px !important;
  }
  ::v-deep .need-input-deposit input {
    color:  #FD1F6D !important;
    font-weight: 700 !important;
    font-size: 14px !important;
  }
  .disableOrder {
    pointer-events: none;
  }
  </style>
